import { deleteAttachment, getSingleAttachment, postAttachment } from '@/api/files'

export default {
  ADD_ATTACHMENT(a, data) {
    return postAttachment(data)
  },
  DELETE_ATTACHMENT(a, data) {
    return deleteAttachment(data)
  },
  FETCH_ONE_ATTACHMENT({ commit }, data) {
    return new Promise((resolve, reject) => {
      getSingleAttachment(data).then(resp => {
        resolve(resp.data)
        commit('SET_ONE_OBJECT', resp.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
}
